import { Link } from 'react-router-dom'
import { Mail, MapPin, /*Linkedin, Send, MessageCircle*/ } from 'lucide-react'
import { useTranslation } from 'react-i18next'

const Footer = () => {
  const currentYear = new Date().getFullYear()
  const { t } = useTranslation()

  const footerLinks = {
    company: [
      { name: t('footer.company.about'), path: '/about' },
      { name: t('footer.company.services'), path: '/services' },
      { name: t('footer.company.contact'), path: '/contact' },
      { name: t('footer.company.vacancies'), path: '/vacancy' },
      { name: t('footer.company.projects'), path: '/projects' },
    ],
    services: [
      { name: t('footer.services.customSoftware'), path: '/services' },
      { name: t('footer.services.cybersecurity'), path: '/services' },
      { name: t('footer.services.cloud'), path: '/services' },
      { name: t('footer.services.consulting'), path: '/services' },
      { name: t('footer.services.support'), path: '/services' },
    ]    
  }
/*
  const socialLinks = [
    { icon: Send, href: '#', label: 'Telegram' },
    { icon: MessageCircle, href: '#', label: 'Whatsapp'},
    { icon: Linkedin, href: '#', label: 'LinkedIn' },
  ]
*/

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container-max">
        {/* Main Footer Content */}
        <div className="py-16 px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Company Info */}
            <div className="lg:col-span-1">
              <Link to="/" className="flex items-center space-x-2 mb-6">
                <div className="w-8 h-8 bg-gradient-to-r from-primary-600 to-accent-600 rounded-lg flex items-center justify-center">
                  <span className="text-white font-bold text-sm">IT</span>
                </div>
                <span className="text-xl font-bold">InfotechPro</span>
              </Link>
              
              <p className="text-gray-400 mb-6 leading-relaxed">
             {t('footer.bigtext')}
              </p>

              <div className="flex space-x-4">
                {/*{socialLinks.map((social, index) => {
                  const IconComponent = social.icon
                  return (
                    <a
                      key={index}
                      href={social.href}
                      className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-primary-600 transition-colors"
                      aria-label={social.label}
                    >
                      <IconComponent className="w-5 h-5" />
                    </a>
                  )
                })}
                */}
              </div>
            </div>

            {/* Company Links */}
            <div>
              <h3 className="text-lg font-semibold mb-6">{t('footer.company.title')}</h3>
              <ul className="space-y-3">
                {footerLinks.company.map((link, index) => (
                  <li key={index}>
                    <Link
                      to={link.path}
                      className="text-gray-400 hover:text-white transition-colors"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Services Links */}
            <div>
              <h3 className="text-lg font-semibold mb-6">{t('footer.services.title')}</h3>
              <ul className="space-y-3">
                {footerLinks.services.map((link, index) => (
                  <li key={index}>
                    <Link
                      to={link.path}
                      className="text-gray-400 hover:text-white transition-colors"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h3 className="text-lg font-semibold mb-6">{t('footer.contact.title')}</h3>
              <div className="space-y-4">
                
                <div className="flex items-start space-x-3">
                  <Mail className="w-5 h-5 text-primary-400 mt-0.5 flex-shrink-0" />
                  <div>
                    <a 
                      href="mailto:infotechpro.kg@gmail.com" 
                      className="block text-gray-400 hover:text-white transition-colors"
                    >
                      infotechpro.kg@gmail.com
                    </a>
                    <a 
                      href="mailto:sup.infotechpro.kg@gmail.com" 
                      className="block text-gray-400 hover:text-white transition-colors"
                    >
                      sup.infotechpro.kg@gmail.com
                    </a>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <MapPin className="w-5 h-5 text-primary-400 mt-0.5 flex-shrink-0" />
                  <div className="text-gray-400">
                    <div>{t('footer.address')}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="border-t border-gray-800 py-6 px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-gray-400 text-sm">
              © {currentYear} {t('footer.copyright')}

            <div className="flex items-start space-x-3">
              <div className="text-gray-400 text-sm">
                {t('footer.INN')}
              </div>
            </div>

            </div>
            
            
            <div className="flex items-center space-x-6 text-sm text-gray-400">
              <Link to="/privacy-policy" className="hover:text-white transition-colors">
                {t('footer.privacy')}
              </Link>
              <Link to="/terms" className="hover:text-white transition-colors">
                {t('footer.terms')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
